import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';

import { SETUP_STEPS } from 'client/artist-ui/utils/next-setup-step';

@observer
class OnboardingProgress extends Component {
	@autobind
	onStepKeyDown (key, complete, e) {
		if (complete || (e.key !== 'Enter' && e.key !== ' ')) {
			return;
		}

		e.preventDefault();
		this.props.onStepActivate(key);
	}

	render () {
		const { artist, onStepPointerEnter, onStepPointerLeave, onStepActivate } = this.props;
		const { searchStatus } = artist;

		return (
			<ul className="progress-tracker progress-tracker--text progress-tracker--text-top progress-tracker--onboarding">
				{ SETUP_STEPS.map((def) => {
					const complete = Boolean(searchStatus[def.key]);

					const classNames = ['progress-step'];

					if (complete) {
						classNames.push('is-complete');
						classNames.push('progress-step--onboarding-complete');
					}

					return (
						<li
							key={ def.key }
							className={ classNames.join(' ') }
							tabIndex={ complete ? -1 : 0 }
							role={ complete ? 'presentation' : 'button' }
							aria-disabled={ complete }
							onMouseEnter={ () => {
								if (!complete) {
									onStepPointerEnter(def.key);
								}
							} }
							onMouseLeave={ onStepPointerLeave }
							onClick={ () => {
								if (!complete) {
									onStepActivate(def.key);
								}
							} }
							onKeyDown={ (e) => this.onStepKeyDown(def.key, complete, e) }
						>
							<div className="progress-marker"></div>
							<h4 className="progress-title">{ def.headingTitle }</h4>
						</li>
					);
				}) }
			</ul>
		);
	}
}

export default OnboardingProgress;
